import { render, staticRenderFns } from "./CampaignListing.vue?vue&type=template&id=63a396d6&scoped=true&"
import script from "./CampaignListing.vue?vue&type=script&lang=js&"
export * from "./CampaignListing.vue?vue&type=script&lang=js&"
import style0 from "./CampaignListing.vue?vue&type=style&index=0&id=63a396d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a396d6",
  null
  
)

export default component.exports